import React, { SVGProps } from 'react';

export const IconItalic = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M13.7 27.2c-.2 0-.3-.1-.3-.32l2.7-21.76c.04-.21.15-.32.35-.32h2.36c.09 0 .15.03.2.1.06.06.08.13.06.22l-2.69 21.76a.3.3 0 0 1-.1.22.3.3 0 0 1-.22.1H13.7Z"/></svg>;
